/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortalDirective} from '../core';
/**
 * Used to flag tab labels for use with the portal directive
 */
export class MdTabLabel extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-tab-label], [mat-tab-label], [mdTabLabel], [matTabLabel]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function MdTabLabel_tsickle_Closure_declarations() {
/** @type {?} */
MdTabLabel.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdTabLabel.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
